



















import CheckBox from '@/views/atoms/CheckBox.vue'
import Global from '@/common/global.js'

export default
  components: {
    CheckBox
  }

  data: () ->
    value: ''

  props:
    list:
      type: Object
      default: []
    defaultNum: 
      type: String
      default: ''
    colorGreen:
      type: Boolean
      default: false
    labelList:
      type: Object
      default: []

  methods: {
    change: (v) ->
      @value = v

    checked: (bool) ->
      @$emit('change', bool, @value)
  }
